/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".categoryLink[_ngcontent-%COMP%]{cursor:pointer}app-scale-chart[_ngcontent-%COMP%]{margin:auto;display:block;background-color:#fff;border:1px solid #000}.flagged[_ngcontent-%COMP%]{color:red}.flagged[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child   em[_ngcontent-%COMP%]::before{position:relative;top:1px;display:inline-block;font-family:'Glyphicons Halflings';font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;content:\"\\e034\"}\n/*# sourceMappingURL=assessment-result-view.component.css.map*/"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/reports/assessment-result-view/assessment-result-view.component.css.shim.ngstyle.js.pre-build-optimizer.js